import {
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CLEAR_PASSWORD_MESSAGE,
  ACCESS_SUCCESS,
  ACCESS_FAIL,
  START_COURSE_SUCCESS,
  NEXT_LESSON_SUCCESS,
  NEXT_CONTENT_SUCCESS,
  NEXT_CONTENT_REQUEST,
  COURSE_PROGRESSION_ERROR,
  PROGRESS_LOADING,
  PROGRESS_LOADED,
  PROGRESS_NOT_FOUND,
  RESET_PROGRESS_SUCCESS,
  RESET_PROGRESS_FAIL,
  START_IMPERSONATION,
  END_IMPERSONATION,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAIL,
  CLEAR_REGISTRATION_DATA,
  NAVIGATION_CONTEXT_LOADED,
  COURSE_CONTENT_LOADED
} from '../actions/types';

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  isLoading: localStorage.getItem('token') ? true : false, // Start as true if token exists
  progressLoading: false,
  isContentProgressing: false,
  user: null,
  progress: null,
  navigationContext: {
    allPathContent: [],
    currentGlobalIndex: -1,
    navigableContent: [],
    totalContent: 0,
    currentContent: null
  },
  lastAction: null,
  awardedBadges: [],
  courseDetails: {},   // { [courseId]: fullCourseObject } — lazy-loaded on click
  isImpersonating: !!localStorage.getItem('originalUserId'),
  originalUserId: localStorage.getItem('originalUserId') || null,
  originalUser: localStorage.getItem('originalUser') ? JSON.parse(localStorage.getItem('originalUser')) : null,
  forgotPasswordMessage: null,
  changePasswordMessage: null,
  registrationData: {
    email: null,
    group: null,
    program: null,
    role: null,
    isAdmin: false
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case PROGRESS_LOADING:
      return {
        ...state,
        progressLoading: true
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload
      };
    case START_COURSE_SUCCESS:
      return {
        ...state,
        progressLoading: false,
        isContentProgressing: false,
        isAuthenticated: true,
        user: action.payload,
        progress: action.payload.progress,
        lastAction: 'START_COURSE'
      };
    case NEXT_CONTENT_REQUEST:
      return {
        ...state,
        isContentProgressing: true
      };
    case NEXT_LESSON_SUCCESS:
    case NEXT_CONTENT_SUCCESS:
      return {
        ...state,
        progressLoading: false,
        isContentProgressing: false,
        isAuthenticated: true,
        user: action.payload,
        progress: action.payload.progress,
        lastAction: action.payload.actionResult?.contentCompleted ?
          (action.payload.actionResult?.contentType === 'submissionForm' ? 'SUBMISSION_FORM_COMPLETED' : 'LESSON_COMPLETED') :
          'NEXT_CONTENT',
        awardedBadges: action.payload.actionResult?.awardedBadges || []
      };
    case PROGRESS_LOADED:
      return {
        ...state,
        progressLoading: false,
        progress: action.payload
      };
    case NAVIGATION_CONTEXT_LOADED:
      return {
        ...state,
        progressLoading: false,
        navigationContext: action.payload
      };
    case PROGRESS_NOT_FOUND:
      return {
        ...state,
        progressLoading: false,
        progress: null,
        lastAction: 'NO_PROGRESS'
      };
    case COURSE_PROGRESSION_ERROR:
      return {
        ...state,
        progressLoading: false,
        isContentProgressing: false,
        lastAction: 'ERROR'
      };
    case RESET_PROGRESS_SUCCESS:
      return {
        ...state,
        progressLoading: false,
        progress: null,
        lastAction: 'RESET_PROGRESS_SUCCESS'
      };
    case RESET_PROGRESS_FAIL:
      return {
        ...state,
        progressLoading: false,
        lastAction: 'RESET_PROGRESS_FAIL'
      };
    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
    case ACCESS_SUCCESS:
      localStorage.setItem('token', action.payload.token);
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        isLoading: false,
        progressLoading: false
      };
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT_SUCCESS:
    case REGISTER_FAIL:
    case ACCESS_FAIL:
      localStorage.removeItem('token');
      localStorage.removeItem('originalUserId');
      localStorage.removeItem('originalUser');
      return {
        ...state,
        token: null,
        user: null,
        progress: null,
        isAuthenticated: false,
        isLoading: false,
        progressLoading: false,
        lastAction: null,
        isImpersonating: false,
        originalUserId: null,
        originalUser: null
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordMessage: action.payload.msg
      };
    case FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        forgotPasswordMessage: null
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordMessage: action.payload.msg
      };
    case CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        changePasswordMessage: null
      };
    case CLEAR_PASSWORD_MESSAGE:
      return {
        ...state,
        changePasswordMessage: null
      };
    case START_IMPERSONATION:
      // Store original user info in localStorage for persistence
      if (action.payload.originalUser) {
        localStorage.setItem('originalUser', JSON.stringify(action.payload.originalUser));
      }
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.impersonatedUser,
        originalUserId: action.payload.originalUserId,
        originalUser: action.payload.originalUser,
        isImpersonating: true,
        isAuthenticated: true
      };
    case END_IMPERSONATION:
      // Clear original user info from localStorage
      localStorage.removeItem('originalUser');
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user,
        originalUserId: null,
        originalUser: null,
        isImpersonating: false,
        isAuthenticated: true
      };
    case VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        registrationData: action.payload
      };
    case VERIFY_EMAIL_FAIL:
      return {
        ...state,
        registrationData: {
          email: action.payload?.email || null,
          group: null,
          program: null,
          role: null,
          isAdmin: false,
          noInvitation: action.payload?.noInvitation || false
        }
      };
    case CLEAR_REGISTRATION_DATA:
      return {
        ...state,
        registrationData: {
          email: null,
          group: null,
          program: null,
          role: null,
          isAdmin: false,
          noInvitation: false
        }
      };
    case COURSE_CONTENT_LOADED:
      return {
        ...state,
        courseDetails: {
          ...state.courseDetails,
          [action.payload.courseId]: action.payload.course
        }
      };
    case 'CLEAR_AWARDED_BADGES':
      return { ...state, awardedBadges: [] };
    default:
      return state;
  }
}
